import { useIntl } from 'umi';

export default function useConfig() {

  const { formatMessage } = useIntl();

  const regionSegmentListFull = [
    { text: formatMessage({ id: 'dbi_reports_all' }), value: 'all' },
    { text: formatMessage({ id: 'dbi_imur_NA' }), value: '北美' },
    { text: formatMessage({ id: 'dbi_imur_W.EU' }), value: '西欧' },
    { text: formatMessage({ id: 'dbi_imur_LATAM' }), value: '拉美' },
    { text: formatMessage({ id: 'dbi_imur_Turkey & Russia' }), value: '土俄' },
    { text: formatMessage({ id: 'dbi_imur_MENA' }), value: '中东' },
    { text: formatMessage({ id: 'dbi_imur_EA' }), value: '东亚' },
    { text: formatMessage({ id: 'dbi_imur_SEA' }), value: '东南亚' },
    { text: formatMessage({ id: 'dbi_imur_SA' }), value: '南亚' },
    { text: formatMessage({ id: 'dbi_imur_Africa' }), value: '非洲' },
  ]

  const regionSegmentListShort = [
    { text: formatMessage({ id: 'dbi_reports_all' }), value: 'all' },
    { text: formatMessage({ id: 'dbi_imur_NA' }), value: '北美' },
    { text: formatMessage({ id: 'dbi_imur_EU' }), value: '欧洲' },
    { text: formatMessage({ id: 'dbi_imur_LATAM' }), value: '拉美' },
    { text: formatMessage({ id: 'dbi_imur_SEA' }), value: '东南亚' },
    { text: formatMessage({ id: 'dbi_imur_MENA' }), value: '中东' },
    { text: formatMessage({ id: 'dbi_imur_Japan' }), value: '日本' },
  ]

  const gcSegmentList = [
    { text: formatMessage({ id: 'dbi_reports_all' }), value: 'all' },
    { text: formatMessage({ id: 'dbi_imur_GR' }), value: '品类研究' },
    { text: formatMessage({ id: 'dbi_imur_CR' }), value: '竞品研究' },
  ]

  const opSegmentList = [
    { text: formatMessage({ id: 'dbi_reports_all' }), value: 'all' },
    { text: formatMessage({ id: 'dbi_imur_CM' }), value: '竞品监测' },
    { text: formatMessage({ id: 'dbi_imur_SR' }), value: '专项研究' },
  ]

  const gameSegmentList = [
    { text: formatMessage({ id: 'dbi_reports_all' }), value: 'all' },
    { text: formatMessage({ id: 'dbi_imur_GC' }), value: '厂商' },
  ]

  const techSegmentList = [
    { text: formatMessage({ id: 'dbi_reports_all' }), value: 'all' },
    { text: formatMessage({ id: 'dbi_imur_VR/AR' }), value: 'VR/AR' },
    { text: formatMessage({ id: 'dbi_imur_Metaverse' }), value: '元宇宙' },
  ]

  const SegmentList = {
    all: null,
    whitePapers: regionSegmentListFull,
    monitoring: regionSegmentListShort,
    genres: gcSegmentList,
    operation: opSegmentList,
    specific: regionSegmentListShort,
    game: gameSegmentList,
    tech: techSegmentList
  }

  const optionData = [
    { value: 'all', text: formatMessage({ id: 'dbi_reports_all' }) },
    { value: 'zh', text: formatMessage({ id: 'dbi_reports_lang_chi' }) },
    { value: 'en', text: formatMessage({ id: 'dbi_reports_lang_eng' }) },
  ];


  const tabs = [
    { id: 'all', label: formatMessage({ id: 'dbi_reports_all' }), pagePoint: 'iMurReportsAll', },
    { id: 'whitePapers', label: formatMessage({ id: 'dbi_imur_reports_tab_white_paper' }), pagePoint: 'iMurReportsWhitePapers', },
    { id: 'monitoring', label: formatMessage({ id: 'dbi_imur_reports_tab_monitoring_reports' }), pagePoint: 'iMurReportsMonitoringReports', },
    { id: 'genres', label: formatMessage({ id: 'dbi_imur_reports_tab_genres' }), pagePoint: 'iMurReportsGenresCompetitors', },
    { id: 'operation', label: formatMessage({ id: 'dbi_imur_reports_tab_operation' }), pagePoint: 'iMurReportsOperationPublishing', },
    { id: 'specific', label: formatMessage({ id: 'dbi_imur_reports_tab_specific' }), pagePoint: 'iMurReportsSpecificReports', },
    { id: 'game', label: formatMessage({ id: 'dbi_imur_reports_tab_game_companies' }), pagePoint: 'iMurReportsGameCompaines', },
    { id: 'tech', label: formatMessage({ id: 'dbi_imur_reports_tab_new_tech' }), pagePoint: 'iMurReportsNewTech', }
  ];

  return {
    SegmentList,
    optionData,
    tabs
  }
}

export const Eng2Chi = {
  whitePapers: "区域白皮书",
  monitoring: "区域监测",
  genres: "品类竞品",
  operation: "运营发行",
  specific: "区域专题",
  game: "游戏厂商",
  tech: "新技术",
}